import { initialPostsState, initialTopicState } from 'mk2/apps/forum/containers/Topic/Topic.constants';
import { PostEntity, PostSchema, TopicEntity, TopicSchema } from 'mk2/apps/forum/schemas';
import { tdenormalize } from 'mk2/helpers/types';
import { AppState } from 'mk2/reducers';
import * as fromEntities from 'mk2/reducers/entities';
import { createDenormalizedEntitiesSelector } from 'mk2/selectors';
import { createSelector } from 'reselect';

export const getTopicState = (state: AppState, slug: string) => {
    if (!state.containers.forum.forumTopic[slug]) {
        return initialTopicState;
    }

    return state.containers.forum.forumTopic[slug];
};

export const getTopicPostsState = (state: AppState, slug: string, hashtags: string[]) => {
    const topicState = getTopicState(state, slug);

    const hashtagsKey = hashtags.length ? hashtags.join(',') : '';
    if (!topicState.posts[hashtagsKey]) {
        return initialPostsState;
    }

    return topicState.posts[hashtagsKey];
};

export const getTopicTopic = createSelector(
    [
        (state: AppState) => state.entities,
        (state: AppState, slug: string) => slug,
    ],
    (entities: fromEntities.EntitiesState, slug: string): TopicEntity => {
        if (!entities[TopicSchema.key]) {
            return null;
        }

        const topics = entities[TopicSchema.key] as { [id: string]: TopicEntity };

        let id: number;
        for (const topic in topics) {
            if (topics[topic].slug === slug) {
                id = topics[topic].id;
                break;
            }
        }

        if (!id) {
            return null;
        }

        return tdenormalize<TopicEntity>(id, TopicSchema, entities);
    },
);

const getDenormalizedPosts = createDenormalizedEntitiesSelector<PostEntity>();
export const getTopicPosts = (state: AppState, slug: string, hashtags: string[]) => getDenormalizedPosts(state, PostSchema, getTopicPostsState(state, slug, hashtags).ids);
